<template>
  <v-menu
    v-model="showMenu"
    :position-x="x"
    :position-y="y"
    absolute
    offset-y
    transition="slide-y-reverse-transition"
    >
    <div class="pa-1 background">
      <div class="font-weight-medium pa-2">
        {{ title }}
      </div>
      <v-btn 
      text
      @click="cancel">
        No
      </v-btn>
      <v-btn 
      text
      @click="agree">
        Yes
      </v-btn>
    </div>
  </v-menu>
</template>

<script>
export default {
  data () {
    return {
      showMenu: false,
      x: 0,
      y: 0,
      title: null,
      resolve: null,
      reject: null
    }
  },
  methods: {
    open (x, y, title) {
      this.x = x
      this.y = y
      this.title = title
      this.showMenu = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    agree () {
      this.resolve(true)
      this.dialog = false
    },
    cancel () {
      this.resolve(false)
      this.dialog = false
    }
  }
}
</script>

<style scoped>

</style>


